<template>
  <div>
    <RangePicker
      :defaultValue="dateValue"
      placement="bottomLeft"
      format="D MMM, h:mm A"
      show-time
      :disabled-date="disabledDate"
      :allowClear="false"
      @change="onRangeChange"
      :getPopupContainer="(trigger) => trigger.parentNode"
      :value="dates"
      @focus="onFocus"
      @open-change="onOpenChange"
      @calendar-change="onCalendarChange"
    />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { RangePicker } from 'ant-design-vue';

export default {
  emits: ['onDateChange'],
  components: { RangePicker },
  data() {
    return {
      dates: this.dateValue,
      rangeMode: 'start',
    };
  },
  props: {
    dateValue: {
      type: Array,
      default: () => [dayjs(), dayjs()],
    },
    customPicker: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onRangeChange(dates) {
      this.dates = dates;

      if (this.customPicker) {
        this.setDates();
      } else {
        this.dates && this.$emit('onDateChange', this.dates);
      }
    },
    getCheckDate(aheadDate) {
      return (
        dayjs(this.dates[1]) >= dayjs(this.dates[0]) &&
        dayjs(this.dates[1]) < aheadDate &&
        dayjs(this.dates[1]) <= dayjs()
      );
    },
    onCalendarChange(dates, dateString, info) {
      if (this.customPicker) {
        const oneDayAhead = dayjs(dates[0]).add(1, 'day');
        const checkEndDate = this.getCheckDate(oneDayAhead);
        this.dates = [
          dates[0],
          checkEndDate
            ? dates[1]
            : dayjs().isBefore(oneDayAhead) && dayjs.isAfter(dates[0])
              ? dayjs()
              : oneDayAhead,
        ];
      }
    },
    setDates() {
      const oneDayAhead = dayjs(this.dates[0]).add(1, 'day');
      const checkEndDate = this.getCheckDate(oneDayAhead);
      this.dates = [
        this.dates[0],
        checkEndDate
          ? this.dates[1]
          : dayjs().isBefore(oneDayAhead)
            ? dayjs()
            : oneDayAhead,
      ];
    },
    disabledDate(current) {
      if (this.customPicker) {
        const oneDayAhead = dayjs(this.dates[0]).add(1, 'day');
        if (this.rangeMode === 'start') {
          return (
            current &&
            (current > dayjs().endOf('day') || current < dayjs().add(-90, 'd'))
          );
        }
        return (
          current &&
          (current > dayjs().endOf('day') ||
            current < dayjs().add(-90, 'd') ||
            current < dayjs(this.dates[0]) ||
            current > oneDayAhead)
        );
      }

      return (
        current &&
        (current > dayjs().endOf('day') || current < dayjs().add(-90, 'd'))
      );
    },
    onFocus(event) {
      if (this.customPicker) {
        if (
          dayjs(this.dates[0]).format('D MMM, h:mm A') ===
          event.srcElement._value
        ) {
          this.rangeMode = 'start';
        } else {
          this.rangeMode = 'end';
        }
      }
    },
    onOpenChange(open) {
      if (this.customPicker) {
        this.dates && this.$emit('onDateChange', this.dates);
      } else {
        this.dates && this.onRangeChange(this.dates);
      }
    },
  },
  watch: {
    rangeMode() {
      if (this.customPicker) {
        this.setDates();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
